import React from 'react';
import { useFormContext } from 'react-hook-form';
import FormInputWithOnChange from '@/component/common/form/input-with-onchange';
import McpCatalogTextAreaField from './McpCatalogTextAreaField';
import McpCatalogSelectField from './McpCatalogSelectField';
import McpCatalogMultiSelectField from './McpCatalogMultiSelectField';
import McpCatalogUrlField from './McpCatalogUrlField';
import {
    MCP_CATALOG_MODE,
    MCP_CATALOG_TYPE_OPTIONS,
    MCP_CATALOG_OS_OPTIONS
} from '../McpCatalogConstant';
import trI18n from '@/common/utils/trI18n';
import { useTranslationSubscription } from '@/hooks/useTranslation';

export default function McpCatalogFormFields({ mode, item }) {
    useTranslationSubscription();
    const { errors } = useFormContext();

    const handleChange = () => {};

    return (
        <div className="mcp-catalog-form-fields">
            {/* カタログバージョン (read-only, edit mode only) */}
            {mode === MCP_CATALOG_MODE.EDIT && item?.version && (
                <div className="form-addTicket mcp-catalog-version-row">
                    <label className="form-addTicket-label">
                        {trI18n('MCP_CATALOG_FIELD_VERSION')}
                    </label>
                    <span className="mcp-catalog-version-display">{item.version}</span>
                </div>
            )}

            {/* MCP名 */}
            <div className="form-addTicket">
                <label className="form-addTicket-label">
                    {trI18n('MCP_CATALOG_FIELD_MCP_NAME')}
                    <span className="required">*</span>
                </label>
                <div className="form-addTicket-input">
                    <FormInputWithOnChange
                        name="mcpName"
                        className="form-control-input form-control-wrapInput form-control-hg40"
                        variant="outlined"
                        autoComplete="off"
                        errorlist={errors}
                        onChange={handleChange}
                        isDisableOnBlur={false}
                    />
                </div>
            </div>

            {/* パッケージ名 */}
            <div className="form-addTicket">
                <label className="form-addTicket-label">
                    {trI18n('MCP_CATALOG_FIELD_PACKAGE_NAME')}
                    <span className="required">*</span>
                </label>
                <div className="form-addTicket-input">
                    <FormInputWithOnChange
                        name="mcpPackageName"
                        className="form-control-input form-control-wrapInput form-control-hg40"
                        variant="outlined"
                        autoComplete="off"
                        errorlist={errors}
                        onChange={handleChange}
                        isDisableOnBlur={false}
                    />
                </div>
            </div>

            {/* パッケージバージョン */}
            <div className="form-addTicket">
                <label className="form-addTicket-label">
                    {trI18n('MCP_CATALOG_FIELD_PACKAGE_VERSION')}
                </label>
                <div className="form-addTicket-input">
                    <FormInputWithOnChange
                        name="mcpPackageVersion"
                        className="form-control-input form-control-wrapInput form-control-hg40"
                        variant="outlined"
                        autoComplete="off"
                        errorlist={errors}
                        onChange={handleChange}
                        isDisableOnBlur={false}
                    />
                </div>
            </div>

            {/* MCPタイプ */}
            <McpCatalogSelectField
                name="mcpType"
                label={trI18n('MCP_CATALOG_FIELD_MCP_TYPE')}
                required={true}
                options={MCP_CATALOG_TYPE_OPTIONS}
            />

            {/* 必要な環境変数 */}
            <div className="form-addTicket">
                <label className="form-addTicket-label">
                    {trI18n('MCP_CATALOG_FIELD_REQUIRED_ENV')}
                </label>
                <div className="form-addTicket-input">
                    <FormInputWithOnChange
                        name="requiredEnv"
                        className="form-control-input form-control-wrapInput form-control-hg40"
                        variant="outlined"
                        autoComplete="off"
                        errorlist={errors}
                        onChange={handleChange}
                        isDisableOnBlur={false}
                    />
                </div>
            </div>

            {/* 説明 */}
            <McpCatalogTextAreaField
                name="description"
                label={trI18n('MCP_CATALOG_FIELD_DESCRIPTION')}
                required={false}
            />

            {/* 用途 */}
            <McpCatalogTextAreaField
                name="purpose"
                label={trI18n('MCP_CATALOG_FIELD_PURPOSE')}
                required={true}
            />

            {/* 対応OS (multiple selection, displayed as chips) */}
            <McpCatalogMultiSelectField
                name="supportedOS"
                label={trI18n('MCP_CATALOG_FIELD_SUPPORTED_OS')}
                required={true}
                options={MCP_CATALOG_OS_OPTIONS}
            />

            {/* ダウンロード先 */}
            <McpCatalogUrlField
                name="downloadURL"
                label={trI18n('MCP_CATALOG_FIELD_DOWNLOAD_URL')}
                required={true}
                mode={mode}
                defaultValue={item?.downloadURL || ''}
            />

            {/* 必要ソフト */}
            <div className="form-addTicket">
                <label className="form-addTicket-label">
                    {trI18n('MCP_CATALOG_FIELD_PREREQUISITES')}
                </label>
                <div className="form-addTicket-input">
                    <FormInputWithOnChange
                        name="prerequisites"
                        className="form-control-input form-control-wrapInput form-control-hg40"
                        variant="outlined"
                        autoComplete="off"
                        errorlist={errors}
                        onChange={handleChange}
                        isDisableOnBlur={false}
                    />
                </div>
            </div>

            {/* 利用時システムプロンプト */}
            <McpCatalogTextAreaField
                name="systemPrompt"
                label={trI18n('MCP_CATALOG_FIELD_SYSTEM_PROMPT')}
                required={false}
            />
        </div>
    );
}
